import React, { useEffect, useState } from "react";
import InsightsNav from "../components/InsightsNav";
import Table from "../components/Table";
import { fetchProjectByID, encode } from "../utils/api";
import moment from "moment";
import ErrorPopup from "../components/ErrorPopup";
import { Link } from "@reach/router";
import SpinningWheel from "../components/SpinningWheel";
import { StyledProject, NoInstances } from "../styles/StyledProject";
const columns = [
  { accessor: "week", Header: "Week", width: 100 },

  {
    accessor: "peopleFirst",
    Header: "People First",
  },
  {
    accessor: "delivery",
    Header: "Delivery",
    type: "number",
  },
  {
    accessor: "commercialManagement",
    Header: "Commercial Management",
  },
  {
    accessor: "technicalQuality",
    Header: "Technical Quality",
  },
  {
    accessor: "clientManagement",
    Header: "Client Management",
  },
  {
    accessor: "product",
    Header: "Product",
  },
  {
    accessor: "action",
  },
];

function Project({ location }) {
  const { state } = location;
  const { id, clubName, clientName, projectName } = state;
  const encoded = encode(clubName);
  const [project, setProject] = useState(null);
  const [error, setError] = useState(null);
  useEffect(() => {
    fetchProjectByID(encoded, id)
      .then((res) => {
        setProject(res);
      })
      .catch((err) => {
        if (err) setError(err);
      });
  }, [encoded, id]);
  if (!project || !project.instances) {
    return <SpinningWheel />;
  }
  const title = projectName ? `${clientName} - ${projectName}` : clientName;
  const reversedInstances = [].concat(project.instances).reverse();
  const rows = reversedInstances.map((instance, i) => {
    const {
      _id,
      commercialManagement,
      peopleFirst,
      product,
      techQuality,
      delivery,
      clientManagement,
      startDate,
    } = instance;

    const date = moment(startDate).format("DD/MM/YY");
    return {
      id: _id,
      week: date,
      peopleFirst: peopleFirst.score,
      delivery: delivery.score,
      commercialManagement: commercialManagement.score,
      technicalQuality: techQuality.score,
      clientManagement: clientManagement.score,
      product: product.score,
      done: "✓",
      action: (
        <Link
          state={{
            instanceID: _id,
            projectID: project._id,
            sdl: project.sdl,
            pdl: project.pdl,
            tdl: project.tdl,
            clientName: clientName,
            projectName: projectName,
            clubName: clubName,
          }}
          className="link"
          to={`/${project._id}/${_id}`}
        >
          {i === 0 ? "Edit" : "View"}
        </Link>
      ),
    };
  });

  return (
    <div>
      {error && <ErrorPopup errors={error.response.data.errors} />}
      <InsightsNav
        id={project._id}
        sdl={project.sdl}
        pdl={project.pdl}
        tdl={project.tdl}
        clubName={clubName}
        projectName={projectName}
        clientName={clientName}
        keyword="Insights"
        startDate={project.startDate}
        endDate={project.endDate}
      />
      {project && project.instances && project.instances.length === 0 ? (
        <NoInstances>
          <h1>There are no instances yet</h1>
          <Link
            className="rag-btn"
            state={{
              projectName: projectName,
              clubName: clubName,
              clientName: clientName,
              projectID: project._id,
              sdl: project.sdl,
              pdl: project.pdl,
              tdl: project.tdl,
            }}
            to={`/${project._id}/new-instance`}
          >
            Create New
          </Link>
        </NoInstances>
      ) : (
        <StyledProject>
          <div className="header">
            <h1>{title}</h1>
            <p className="team">
              Team: {project.sdl} - SDL, {project.tdl} - TDL, {project.pdl} -
              PDL
            </p>
          </div>
          <Table
            columns={columns}
            data={rows}
            getCellProps={(cellInfo) => {
              const value = cellInfo.value;
              let bg;
              if (value && typeof value === "number") {
                if (value < 3) {
                  bg = "#FF323C";
                }
                if (value === 3) {
                  bg = "#FF9432";
                } else if (value > 3) {
                  bg = "#35BF6D";
                }
              } else bg = "transparent";
              return {
                backgroundColour: bg,
              };
            }}
          />
        </StyledProject>
      )}
    </div>
  );
}

export default Project;
